import React from 'react';
import parser from 'html-react-parser';
import WarningMessage from '@/presentation/reusables/WarningMessage';

import { WrapperExtraCaption } from '../styled';

interface IProps {
  subtitle?: any;
  subtitle2?: any;
  title: string;
  title2?: string;
  messageInfo?: string;
}

const DialogExtraCaption = ({
  subtitle,
  subtitle2,
  title,
  title2,
  messageInfo
}: IProps) => (
  <WrapperExtraCaption>
    <span>{title}</span>
    {title2 && <span>{title2}</span>}
    {subtitle && (
      <span>{typeof subtitle === 'string' ? parser(subtitle) : subtitle}</span>
    )}
    {subtitle2 && (
      <span>
        {typeof subtitle2 === 'string' ? parser(subtitle2) : subtitle2}
      </span>
    )}
    {messageInfo && typeof messageInfo === 'string' && (
      <WarningMessage
        message={messageInfo}
        styledProps={{
          background: '#ECF4F9',
          padding: '16px',
          alignItems: 'start',
          iconSize: 16,
          fontSize: '12px',
          gap: '12px'
        }}
      />
    )}
  </WrapperExtraCaption>
);

DialogExtraCaption.defaultProps = {
  subtitle: ''
};
export default DialogExtraCaption;
